import { LEASING_TRANSFER_COST_NOTE } from "@/app/utils/constants/backend/offers/offer-disclaimers";
import type { OfferFormDataT } from "@/app/types/offers";

/**
 * Get the uniform fine-print note stating that transfer costs are charged
 * separately.
 *
 * Only relevant for leasing offers that actually carry transfer costs. Without
 * a positive amount the note would contradict the "0,00 €" or "-" shown in the
 * pricing column.
 *
 * @param pricing - The offer pricing object
 * @returns The note text or null when it must not be shown
 */
export const getLeasingTransferCostNote = (
  pricing: OfferFormDataT["pricing"] | null | undefined
): string | null => {
  if (pricing?.type !== "leasing") {
    return null;
  }

  return (pricing.ueberfuehrungskosten ?? 0) > 0
    ? LEASING_TRANSFER_COST_NOTE
    : null;
};
